/* eslint-disable no-func-assign */
import React from 'react';
import { listTypes, statusTypes, useMatchData, getMatchListOdds } from "../../utils";
import ToggleButton from "../../../shared/components/ToggleButton";
import BettingLines from "../BettingLines/BettingLines";
import ExternalLinkIcon from "../../../shared/svg/ExternalLinkIcon";
import { useReactAppState } from "../../../shared/containers/utils";
import { d3BettingAPI } from "../../../shared/api/variables";
import { fetchClient } from '../../../shared/api/fetching';
import { useQuery } from 'react-query';

function Odds({ betMgmCompetitionIds = null }) {
  const { mediaQueries, t, apiList, betMgmUrl } = useReactAppState();
  const { d3SportsAPI } = apiList || {};
  const { isMediumLargeMin } = mediaQueries || {};
  const { listType, homeClubData, awayClubData, status, mgmId } = useMatchData();
  if (listType !== listTypes.odds) {
    return null;
  }

  const d3BettingEndpoint = mgmId ? d3BettingAPI({ mgmId, mgmCompetitionId: betMgmCompetitionIds }) : null;

  const {
    data: oddsData,
  } = useQuery({
    queryKey: [`mls-match-odds`, { mgmId }],
    queryFn: () => fetchClient({ endpoint: d3BettingEndpoint, apiURL: d3SportsAPI }),
    enabled: status?.abbreviation === statusTypes.pre && d3BettingEndpoint !== null
  });

  const regularMatchResults = oddsData?.length ? getMatchListOdds(oddsData) : {};

  return (
    <div className="mls-o-match-strip__odds mls-o-odds">
      {
        status?.abbreviation === statusTypes.pre && Object.keys(regularMatchResults)?.length
          ? (
            <>
              <div className="mls-o-odds__group">
                {
                  homeClubData?.abbreviation
                    ? <BettingLines label={homeClubData.abbreviation} line={regularMatchResults?.homePrice} />
                    : null
                }
                <BettingLines label={t("tie")} line={regularMatchResults?.tiePrice} />
                {
                  awayClubData?.abbreviation
                    ? <BettingLines label={awayClubData.abbreviation} line={regularMatchResults?.awayPrice} />
                    : null
                }
              </div>
              {
                isMediumLargeMin
                  ? (
                    <div className="mls-o-odds__group">
                      <BettingLines label={t("goals")} line={regularMatchResults?.totalGoals} hasOutline={false} />
                      <BettingLines label={t("over")} line={regularMatchResults?.overPrice} />
                      <BettingLines label={t("under")} line={regularMatchResults?.underPrice} />
                    </div>
                  )
                  : null
              }
              <ToggleButton href={betMgmUrl ? betMgmUrl : null} target="_blank" rel="noreferrer" className="mls-o-odds__link">
                <div className="mls-o-odds__link-info">
                  <div className="mls-o-odds__link-title">{t("match_bet_now")}</div>
                  <div className="mls-o-odds__link-description">{t("match_bet_mgm")}</div>
                </div>
                <div className="mls-o-odds__icon"><ExternalLinkIcon size={"x-small"} /></div>
              </ToggleButton>
            </>
          )
          : null
      }
    </div>
  );
}

Odds = React.memo(Odds);

export default Odds;
